import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import { PhotoSwipe } from 'react-photoswipe';
import API from '../../config/config';
import Link from 'next/dist/client/link';

const ImageTableCausel = (props: any) => {
  const [state, setstate] = useState({
    isOpen: false
  });

  const items: any = [];
  // props.data.ImageTableCaruosel.map((photoitem:any,i:number)=>{
  //     items.push({src:API.baseUrl+photoitem.image.url,w:photoitem.image.width,h:photoitem.image.height})
  // })

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1200 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1199, min: 990 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 990, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    minmobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const Pophandle = () => {
    setstate({
      isOpen: !state.isOpen
    });
  };

  const CustomRightArrow = ({ onClick, ...rest }: any) => {
    return (
      <button onClick={() => onClick()} className="btncarousel-widget btncarousel-widget-arrow-right" aria-label="fa-chevron-right">
        <span className="fas fa-chevron-right ImageTableCausel-arrow " />
      </button>
    );
  };

  const CustomLeftArrow = ({ onClick, ...rest }: any) => {
    return (
      <button onClick={() => onClick()} className="btncarousel-widget btncarousel-widget-arrow-left" aria-label="fa-chevron-left">
        <span className="fas fa-chevron-left ImageTableCausel-arrow " />
      </button>
    );
  };

  return (
    <div className="ImageTableCausel-background">
      <div className="container-fluid">
        <div className="container">
          <h2 className="ImageTableCausel-h2">{props.data.title} </h2>
          <div className="ImageTableCaousel-flex-image">
            <Row className="ImageTableCaousel-flex-image" xs={2} md={4}>
              {props.data.Activities.map((item: any, i: number) => {
                return (
                  <Col key={i}>
                    <img
                      className="ImageTableCarousel-excercise-img"
                      src={API.baseUrl + item.icon.url}
                      alt="exercise"
                    />
                    <h6 className="ImageTableCarousel-excercise-img-h6">{item.label}</h6>
                  </Col>
                );
              })}
            </Row>
          </div>

          <Carousel
            swipeable={true}
            draggable={true}
            showDots={true}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={false}
            arrows={true}
            keyBoardControl={true}
            customTransition="transform 500ms ease-in-out"
            transitionDuration={0}
            containerClass="carousel-container"
            removeArrowOnDeviceType={['tablet', 'mobile']}
            deviceType={props.deviceType}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
            customRightArrow={<CustomRightArrow />}
            customLeftArrow={<CustomLeftArrow />}
          >
            {props.data.ImageTableCaruosel.map((item: any, i: number) => {
              items.push({ src: API.baseUrl + item.image.url, w: item.image.width, h: item.image.height });
              return (
                <img
                  key={i}
                  onDoubleClick={Pophandle}
                  draggable={false}
                  className="ImageTableContainer-img"
                  src={API.baseUrl + item.image.url}
                  alt=""
                />
              );
            })}
          </Carousel>
          <div className="ImageTableCaousel-flex-image">
            <h6 className="Image-table-button-h6">
              <Link href="/product/sports-towel/">
                <a className="Image-table-button-buynow">Shop Now</a>
              </Link>
            </h6>
          </div>
        </div>
      </div>
      <PhotoSwipe isOpen={state.isOpen} items={items} onClose={Pophandle} />
    </div>
  );
};

export default ImageTableCausel;
